import React from "react";
import { NavLink } from "react-router-dom";

import "./header.styles.css";

// import { makeStyles } from "@material-ui/styles";
// import { colors, fontSizes, fonttypes } from "../../Css";
// import "./header.styles.css";

// import TaskCreation from "../Modal/TaskCreation";
// import InviteCohort from "../Modal/InviteCohort";

// const useStyles = makeStyles({
//   root: {
//     width: "100%",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     height: 78,
//     borderBottom: "1px solid #D8D8D8",
//     paddingLeft: 121,
//     paddingRight: 121,
//     position: "relative",
//     "@media screen and (max-width:1024px)": {
//       height: "auto !important",
//       marginBottom: 20,
//       paddingRight: 20,
//     },
//     "@media screen and (max-width:1440px)": {
//       paddingRight: 50,
//       paddingLeft: 50,
//     },
//   },
//   searchAndSearchListExpandBar: {
//     display: "flex",
//     flexDirection: "column",
//     position: "relative",
//   },
//   headerSearch: {
//     width: 469,
//     height: 38,
//     position: "relative",
//     backgroundColor: "#EEEDF1",
//     display: "flex",
//     alignItems: "center",
//     borderRadius: 21,
//     "& input": {
//       height: 38,
//       width: 544,
//       border: "none",
//       backgroundColor: "transparent",
//       outline: "none",
//       fontFamily: fonttypes.sg_regular,
//       fontSize: fontSizes.xsm,
//       color: colors.black,
//     },
//   },
//   headerSearchResulList: {
//     backgroundColor: colors.white,
//     height: 0,
//     boxShadow: `0px 8px 10px rgba(0, 0, 0, 0.0996504)`,
//     position: "absolute",
//     width: 469,
//     overflowX: "scroll",
//     transition: "0.6s ease-in-all",
//     zIndex: 9999,
//   },

//   showHeaderSearchResultList: {
//     height: 168,
//   },
//   ResulList: {
//     listStyle: "none",
//     margin: 0,
//     padding: 0,
//     marginLeft: 30,
//   },
//   ResulListItem: {
//     marginTop: 14,
//     display: "block",
//     "& a": {
//       color: "#313131",
//       "& h6": {
//         fontFamily: fonttypes.sg_semibold,
//         fontSize: fontSizes.xsm,
//         marginBottom: 3,
//       },
//       "& p": {
//         fontFamily: fonttypes.sg_regular,
//         fontSize: fontSizes.sm,
//       },
//     },
//   },

//   rightSection: {
//     display: "flex",
//     justifyContent: "space-between",
//     "& span": {
//       display: "flex",
//       fontFamily: fonttypes.sg_medium,
//       fontSize: 14,
//       color: "#000",
//       alignItems: "center",
//       marginRight: 134,
//       "& svg": {
//         marginRight: 5,
//       },
//     },
//   },
//   rightSectionInviteText: {
//     fontFamily: fonttypes.sg_medium,
//     fontSize: fontSizes.sm,
//     display: "flex",
//     alignItems: "center",
//     "& svg": {
//       marginLeft: 16,
//     },
//   },
//   rightSectionTaskBtn: {
//     backgroundColor: colors.lightRed,
//     borderRadius: 4,
//     fontFamily: fonttypes.sg_medium,
//     fontSize: fontSizes.sm,
//     color: colors.red,
//     display: "flex",
//     alignItems: "center",
//     border: "none",
//     "& svg": {
//       marginRight: 5,
//     },
//   },

//   rightSectionUsername: {
//     display: "flex",
//     borderRadius: 100,
//     justifyContent: "center",
//     alignItems: "center",
//     width: 37,
//     height: 37,
//     fontFamily: fonttypes.sg_medium,
//     fontSize: fontSizes.xsm,
//     color: colors.white,
//     backgroundColor: "#313131",
//   },
// });

// /**
//  * @param {Function} setTaskModal: this is a callback function that opens the task modal
//  */
// const Header = ({
//   isNewCohortVisible,
//   onCloseModal,
//   url,
//   state,
//   showAddNewCourses,
//   showModal
// }) => {
//   const classes = useStyles();
//   const [taskVisible, setTaskVisible] = useState(false);

//   const onOpenTaskModal = () => {
//     setTaskVisible(true);
//   };

//   const onCloseTask = (state) => {
//     setTaskVisible(state);
//   };

//   const TaskModal = ({ isVisible, onClose, title, type, url }) => {
//     return (
//       <TaskCreation
//         isVisible={isVisible}
//         onClose={onClose}
//         title={title}
//         type={type}
//         url={url}
//       />
//     );
//   };
//   return (
//     <div className={classes.root}>
//       <div></div>
//       <div className={classes.rightSection}>
//         {/* {JSON.parse(window.localStorage.getItem("klen_school_data"))
//           .user_type === "student" ? null : (
//           <span style={{ cursor: "pointer" }} onClick={showModal}>
//             <svg
//               width="19"
//               height="19"
//               viewBox="0 0 19 19"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 d="M9.93746 7.75004C9.93746 6.30629 8.75621 5.12504 7.31246 5.12504C5.86871 5.12504 4.68746 6.30629 4.68746 7.75004C4.68746 9.19379 5.86871 10.375 7.31246 10.375C8.75621 10.375 9.93746 9.19379 9.93746 7.75004ZM7.31246 8.62504C6.83121 8.62504 6.43746 8.23129 6.43746 7.75004C6.43746 7.26879 6.83121 6.87504 7.31246 6.87504C7.79371 6.87504 8.18746 7.26879 8.18746 7.75004C8.18746 8.23129 7.79371 8.62504 7.31246 8.62504ZM13 10.375C13.9712 10.375 14.75 9.59629 14.75 8.62504C14.75 7.65379 13.9712 6.87504 13 6.87504C12.0287 6.87504 11.2412 7.65379 11.25 8.62504C11.25 9.59629 12.0287 10.375 13 10.375ZM9.49121 0.758789C4.66121 0.758789 0.741211 4.67879 0.741211 9.50879C0.741211 14.3388 4.66121 18.2588 9.49121 18.2588C14.3212 18.2588 18.2412 14.3388 18.2412 9.50879C18.2412 4.67879 14.3212 0.758789 9.49121 0.758789ZM4.10996 13.98C4.70496 13.5075 6.09621 13.0088 7.31246 13.0088C7.37371 13.0088 7.44371 13.0175 7.51371 13.0175C7.72371 12.4575 8.09996 11.8888 8.65121 11.39C8.16121 11.3025 7.69746 11.25 7.31246 11.25C6.17496 11.25 4.34621 11.6438 3.17371 12.5013C2.73621 11.5913 2.49121 10.5763 2.49121 9.50004C2.49121 5.64129 5.63246 2.50004 9.49121 2.50004C13.35 2.50004 16.4912 5.64129 16.4912 9.50004C16.4912 10.55 16.255 11.5475 15.835 12.4488C14.96 11.9325 13.77 11.6875 13 11.6875C11.67 11.6875 9.06246 12.3963 9.06246 14.05V16.4825C7.07621 16.3688 5.30871 15.4238 4.10996 13.98Z"
//                 fill="black"
//               />
//             </svg>
//             Invite people
//           </span>
//         )} */}

//         <button
//           className={classes.rightSectionTaskBtn}
//           onClick={onOpenTaskModal}
//         >
//           <svg
//             width="13"
//             height="13"
//             viewBox="0 0 13 13"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               d="M11 0H2C0.89543 0 0 0.89543 0 2V11C0 12.1046 0.89543 13 2 13H11C12.1046 13 13 12.1046 13 11V2C13 0.89543 12.1046 0 11 0Z"
//               fill="#FF3A00"
//             />
//             <path d="M6.5 3V10" stroke="white" strokeLinecap="round" />
//             <path d="M10 6.5H3" stroke="white" strokeLinecap="round" />
//           </svg>
//           Create a task
//         </button>
//       </div>

//       <TaskModal
//         isVisible={taskVisible}
//         title="Tasks"
//         type={
//           JSON.parse(window.localStorage.getItem("klen_school_data"))
//             .user_type
//         }
//         onClose={() => onCloseTask(state)}
//         url={url}
//       />

//       <InviteCohort
//         isVisible={isNewCohortVisible}
//         title="Invite new cohort"
//         onCloseModal={() => onCloseModal(state)}
//       />
//     </div>
//   );
// };

// export default Header;

const Header = () => {
  return (
    <section className="header regular__header">
      <section></section>
      <section className="header--right">
        <NavLink to="/product">Product</NavLink>
        <NavLink to="/signup">Sign up</NavLink>
        <NavLink to="/login">Sign in</NavLink>
      </section>
    </section>
  );
};

export default Header;
